export const WorkspaceMfaRequirement = {
    REQUIRED: 'required',
    ON_NEXT_LOGIN: 'onNextLogin',
    OPTIONAL: 'optional',
};
